import { put, select, takeLatest } from 'redux-saga/effects'
import { getAddMedicationAdministeredSelector } from '../selectors'
import { setAddMedicationAdministeredData } from '../store/addMedicationAdministered.actions'
import { AddMedicationAdministeredConstants } from '../store/addMedicationAdministered.constants'
import { IAddMedicationAdministeredState } from '../store/addMedicationAdministered.types'

export function* setResponse() {
  const addMedicationAdministeredState: IAddMedicationAdministeredState = yield select(
    getAddMedicationAdministeredSelector
  )
  const { response, responsePNNV, medicationAdministered, addMedicationAdministeredData } =
    addMedicationAdministeredState
  const selectedMedication = addMedicationAdministeredData.filter(
    (medication) => medication.key === medicationAdministered?.key
  )
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].response = response
    selectedMedication[0].responsePNNV = responsePNNV
    yield put(setAddMedicationAdministeredData(addMedicationAdministeredData))
  }
}
export function* setResponseSaga() {
  yield takeLatest(
    [AddMedicationAdministeredConstants.SET_RESPONSE_VALUE, AddMedicationAdministeredConstants.SET_RESPONSE_VALUE_PNNV],
    setResponse
  )
}
